// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tdYm","footer":"styles_footer__2NHom"};